import React, { Component } from 'react';
import './assessment.scss';
import SessionCache from '../routes/session-cache';
import SchoolApi from '../../apis/school'
import PillButton from '../common/pill-button-select/pill-button-select'
import DropdownV4 from '../common/dropdown-v4/dropdown';
import Dropdown from '../common/dropdown-v2/dropdown';
import { ImageConstants, } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'
import HomeworkList from '../homework/homework'
import TestApi from '../../apis/test'
import TestList from '../tests-v3/test-list/test-list'
import MasterDataApi from '../../apis/master-data'
import HomeworkApi from '../../apis/homework'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';
import { Tooltip, Modal, ModalBody, } from "reactstrap";

import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import NotificationModel from '../tests-v3/test-list/notification/notification'
import SuccessComponent from '../tests-v3/test-list/success/success'
import CommonUtils from '../../utility/common-utilities'

class AssessmentList extends Component {

    state = {
        activeStudents: 0,
        chapters: [],
        showSuccess: false
    }
    eloHash = {}
    conceptHash = {}
    durationDropdown = [{ title: "15 Mins", value: 15 }, { title: "30 Mins", value: 30 }, { title: "45 Mins", value: 45 }]
    progressConfig = { textSize: '50px', textColor: '#41A2FC', pathColor: "#6AE5D3", trailColor: "#FFE4E4" }
    accessRights = SessionCache.getAllowedModule()

    componentDidMount() {
        this.getClasses()
    }

    componentWillUnmount() {
    }

    onCloseCreateModal = () => {
        this.setState({
            type: "",
            duration: "",
            selectedDate: undefined,
            assessmentIndex: -1,
            diagnosticIndex: -1,
            homeworkIndex: -1,
        })
        this.startDate = undefined
    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                this.setState({
                    classDropdownItems: classes,
                    boardsDropdownItems: boards,
                    selectedBoard: boards[0]?.title,
                    selectedClass: classes[0].title,
                    orgBoard: boards[0]?.title,
                    orgClass: classes[0].title,
                    reloadDropdown: true,
                    reloadBoard: true
                }, () => {
                    this.getSections()
                    this.getChapterDetail({ board: this.state.selectedBoard, class: this.state.selectedClass })
                    this.setState({ reloadDropdown: false, reloadBoard: false })
                })
            }).catch(err => {
            })
    }

    getChapterDetail(payload = {}) {
        if (!payload.class || !payload.board) return
        SchoolApi.getChapterDetail(payload)
            .then(response => {
                let chapters = response.chapters || []
                this.setState({
                    chapters, showList: false,
                    masterDataId: response.masterDataId,
                    totalActiveStudents: response.totalActiveStudents || 0
                })

                chapters.forEach(chapter => {
                    let concepts = []
                    for (let j = 0; j < chapter.concepts?.length; j++) {
                        let concept = chapter.concepts[j]
                        concepts.push({
                            title: concept.title,
                            value: concept.key,
                            order: j + 1
                        })
                    }

                    this.conceptHash[chapter.key] = concepts
                });
            }).catch(err => {
            })
    }

    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                for (let i = 0; i < response.response.length; i++) {
                    sections.push({
                        title: response.response[i].section,
                        value: response.response[i]._id,
                    })
                }
                this.setState({ sectionDropdownItems: sections, selectedSection: "", reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })
    }

    getQuestionList(item, type) {

        let payload = {
            chapterKey: item.key,
            class: this.state.selectedClass,
        }

        this.setState({ isLoading: true, questions: [] })
        if (type == "DIAGNOSTIC") {

            TestApi.getDiagnosticQuestionList(payload)
                .then(response => {

                    this.setState({ questions: response?.questions, isLoading: false })
                }).catch(err => {
                    this.setState({ isLoading: false, questions: [] })
                })
        } else {
            TestApi.getAssessmentQuestionList(payload)
                .then(response => {

                    this.setState({ questions: response?.questions, isLoading: false })
                }).catch(err => {
                    this.setState({ isLoading: false, questions: [] })
                })
        }
    }

    onSelectDropDown = (option, key) => {
        this.setState({ [key]: option?.value }, () => {
            if (key == "selectedClass" || key == "selectedBoard") {
                this.getSections()
            }
            if (key == "selectedSection") {
                this.setState({ section: option?.title })
            }

        })
    }

    getChapterStatusClass(value) {
        if (value == "COMPLETED") {
            return "green-circle"
        }
        if (value == "ONGOING") {
            return "orange-circle"
        }
        return "red-circle"
    }

    addDiagnostic(item, index, type) {
        this.setState({
            showDiagnosticCreate: true,
            diagnosticIndex: index,
            type,
            selectedChapter: item,
            questions: [],
            errMessage: "",
            addIndex: index
        }, () => {
            this.getQuestionList(item, "DIAGNOSTIC")
        })
    }

    addHomework(item, index, type) {

        let conceptDropdown = this.conceptHash[item.key]
        this.setState({
            showHomeworkCreate: true,
            homeworkIndex: index,
            type,
            conceptDropdown,
            selectedChapter: item,
            selectedConcept: "",
            addIndex: index,
            errMessage: ""
        }, () => {

            this.getWorkflowNodes()
            this.getEloDetails()
        })

    }

    addAssessment(item, index, type) {
        this.setState({
            showAssessmentCreate: true,
            assessmentIndex: index,
            type,
            selectedChapter: item,
            questions: [],
            errMessage: "",
            addIndex: index
        }, () => {
            this.getQuestionList(item)
        })
    }

    onClickCreate() {
        if (this.state.type === "Assessment") this.createAssessment("NORMAL")
        if (this.state.type === "Diagnostic") this.createAssessment("DIAGNOSTIC")
        if (this.state.type === "Homework") this.createHomework()
    }

    createAssessment(type) {

        if (this.saving) return
        let payload = {
            class: this.state.orgClass,
            board: this.state.orgBoard,
            duration: this.state.duration,
            chapters: [{ key: this.state.selectedChapter?.key, title: this.state.selectedChapter?.title }],
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()) : "",
            type,
            masterDataId: this.state.masterDataId
        }

        if (this.state.orgSectionId) {
            payload.sectionId = this.state.orgSectionId
            payload.section = this.state.orgSection
        }

        payload.questions = this.getQuestionPayload(this.state.questions || [])
        let validation = this.validateAssessmentPayload(payload)

        if (!validation) return

        this.saving = true

        TestApi.createTest(payload).then(response => {
            this.saving = false
            this.setState({ diagnosticIndex: -1, assessmentIndex: -1, })
            let assessment = { ...response.data }
            if (!assessment.totalUsers) {
                this.onCLickNotitification(assessment, "WHATSAPP")
            } else {
                this.showSuccessModal(assessment)
            }
        }).catch(err => {
            this.saving = false
            this.setState({ diagnosticIndex: -1, assessmentIndex: -1, })
            this.showToaster("info", "Something went wrong")

        })
    }

    createHomework() {
        if (this.saving) return
        let payload = {
            class: this.state.orgClass,
            board: this.state.orgBoard,
            masterDataId: this.state.masterDataId,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()) : "",
            type: "STANDARD",
            approximateQuestions: this.state.questionCount || 0,
            approximateTime: this.state.approximateTime || 0,
            chapter: this.state.selectedChapter?.key,
            concepts: this.state.selectedConcept,
            conceptList: this.state.conceptList
        }
        if (this.state.orgSectionId) {
            payload.sectionId = this.state.orgSectionId
            payload.section = this.state.orgSection
        }
        let validation = this.validateHomeworkPayload(payload)
        if (!validation) return

        this.saving = true

        HomeworkApi.createHomework(payload).then(response => {
            this.saving = false
            this.setState({ showHomeworkCreate: false, homeworkIndex: -1 })
            let assessment = { ...response.data }
            if (!assessment.totalUsers) {
                this.onCLickNotitification(assessment, "WHATSAPP")
            } else {
                this.showSuccessModal(assessment)
            }
        }).catch(err => {
            this.saving = false
            this.setState({ showHomeworkCreate: false, homeworkIndex: -1 })
            this.showToaster("error", "Something went wrong")
        })
    }

    getWorkflowNodes(payload = {}) {
        payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            chapterKey: this.state.selectedChapter?.key,
            masterDataId: this.state.masterDataId
        }
        MasterDataApi.getWorkflowNodes(payload)
            .then(response => {
                response = response.data
                this.eloHash = {}
                for (let i = 0; i < response.length; i++) {
                    let chapter = response[i], elos = []

                    for (let j = 0; j < chapter.elos?.length; j++) {
                        let elo = chapter.elos[j]
                        elos.push({
                            title: elo.title,
                            value: elo.id,
                            conceptTitle: chapter.conceptTitle,
                            conceptValue: chapter.conceptKey
                        })
                    }
                    if (this.eloHash[chapter.conceptKey]) {
                        this.eloHash[chapter.conceptKey].push(...elos)
                    } else {
                        this.eloHash[chapter.conceptKey] = elos
                    }
                }

            }).catch(err => {
            })
    }
    getEloDetails = () => {

        let payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            chapter: this.state.selectedChapter?.key,
            concepts: this.state.selectedConcept || [],
        }

        if (!payload.class || !payload.board || !payload.chapter) return

        HomeworkApi.getHomeworkEloDetails(payload)
            .then(response => {
                this.setState({
                    questionCount: response.questionCount,
                    contents: response.content,
                    approximateTime: response.questionCount, //ask by ravi
                    isLoading: false
                })
            }).catch(err => {
            })
    }


    getQuestionPayload(questions) {
        let result = questions.map(item => {
            item.mark = item?.content?.mark || CommonUtils.getMarkByComplexity(item?.content?.complexity)
            delete item.content
            return item
        })
        return result
    }

    validateHomeworkPayload = (payload) => {
        if (!payload.board) {
            this.setState({ errMessage: "Please Select the Board" })
            return false
        }

        if (!payload.class) {
            this.setState({ errMessage: "Please Select the Class" })
            return false
        }

        if (!payload.chapter) {
            this.setState({ errMessage: "Please Select the Chapters" })
            return false
        }

        if (!payload.concepts || payload.concepts.length == 0) {
            this.setState({ errMessage: "Please Select the Concepts" })
            return false
        }

        if (payload.type == 'ADAPTIVE' && !payload.streamingLogic) {
            this.setState({ selectStreamingLogic: true })
            return false
        }

        if (!payload.dueDate) {
            this.setState({ errMessage: "Please Select the Due Date" })
            return false
        }

        this.setState({ errMessage: "" })
        return true

    }

    validateAssessmentPayload(payload) {
        if (!payload?.board) {
            this.setState({ errMessage: "Please Select the Board" })
            return false
        }

        if (!payload?.class) {
            this.setState({ errMessage: "Please Select the Class" })
            return false
        }

        if (!payload.chapters?.length) {
            this.setState({ errMessage: "Please Select the Chapters" })
            return false
        }

        if (!payload.duration) {
            this.setState({ errMessage: "Please Select the Duration" })
            return false
        }

        if (!payload.dueDate) {
            this.setState({ errMessage: "Please Select the Due Date" })
            return false
        }

        if (!payload?.questions?.length) {
            this.setState({ errMessage: "No Questions Available in these Chapters" })
            return false
        }

        this.setState({ errMessage: "" })
        return true
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onMultiSelectDropdown(options, key) {

        let value = [], conceptList = []
        options = options.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)

            if (key == "selectedConcept") {
                if (this.eloHash[option?.value]) {

                    let eloContruct = []
                    let elo = this.eloHash[option?.value]
                    elo.map((e) => {
                        eloContruct.push({ id: e.value })
                        return {
                            ...e,
                            conceptName: `Concept ${i + 1}`
                        }
                    })

                    conceptList.push({
                        key: option?.value,
                        elos: eloContruct
                    })
                }
            }
        }
        this.setState({ [key]: value, conceptList }, () => {
            this.getEloDetails()
        })
    }

    onClickGo = () => {
        let payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard
        }
        if (this.state.selectedSection) {
            payload.sectionId = this.state.selectedSection
        }
        this.setState({
            orgClass: this.state.selectedClass,
            orgBoard: this.state.selectedBoard,
            orgSectionId: this.state.selectedSection,
            type: ""
        })

        this.getChapterDetail(payload)
    }


    onCLickNotitification(item, type) {
        this.setState({ notificationType: type, selectedItem: item, showNotification: true })
    }

    hideNotification = () => {
        this.setState({ showNotification: false })
    }

    showSuccessModal = (item) => {
        this.setState({ showSuccess: true, selectedItem: item })
    }

    onInviteMoreStudent = () => {
        this.setState({ showSuccess: false, notificationType: "WHATSAPP", showNotification: true })
    }

    closeSuccess = () => {
        this.setState({ showSuccess: false })
    }


    renderNotificationModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNotification} size={'lg'}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideNotification} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="header-text text-center pt-4">
                        <span>SHARE THE INVITE WITH STUDENTS</span>
                    </div>
                    <NotificationModel type={this.state.notificationType} assessment={this.state.selectedItem} onChangeType={this.onChangeType} onOk={this.hideNotification} />
                </ModalBody>
            </Modal>
        )
    }


    renderFilter() {
        return (
            <div className="row">
                {
                    this.state.boardsDropdownItems?.length > 1 ?
                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                            <div className="filter-input-label">
                                Boards
                            </div>
                            <div>
                                {
                                    !this.state.reloadBoard ?
                                        <Dropdown
                                            placeholder='Select a board'
                                            options={this.state.boardsDropdownItems}
                                            onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                            text={"title"}
                                            value={this.state.selectedBoard}

                                        /> : ""}
                            </div>
                        </div>
                        : ""
                }
                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                    <div className="filter-input-label">
                        Class
                    </div>
                    <div>{
                        !this.state.reloadDropdown ?
                            <Dropdown
                                placeholder='Select a Class'
                                options={this.state.classDropdownItems}
                                onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                text={"title"}
                                value={this.state.selectedClass}

                            /> : ""}
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                    <div className="filter-input-label">
                        Section
                    </div>
                    <div>
                        {
                            !this.state.reloadDropdown ?
                                <Dropdown
                                    key="class"
                                    placeholder='Select a Section'
                                    options={this.state.sectionDropdownItems}
                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSection")}
                                    text={"title"}
                                    value={this.state.selectedSection}
                                >
                                </Dropdown>
                                : ""
                        }
                    </div>
                </div>
                <div className="col my-auto">
                    <div className="filter-button  d-inline-block pt-5">
                        <button className={`cw-button`} onClick={this.onClickGo.bind(this)}>{"GO"}</button>
                    </div>
                </div>
            </div>

        )
    }

    onSelectDuration = (value) => {
        this.setState({ duration: value })
    }

    handleDateEvent = (event, picker) => {
        this.startDate = picker.startDate
        this.setState({ selectedDate: new Date(picker.startDate).toLocaleDateString() });
    }

    renderAssessmentCreateCard() {
        return (
            <div className="assessment-card" ref={ref => this.cardRef = ref}>
                <div className="close-icon">
                    <img alt="" className="icon-15 cursor-pointer" src={getImageSource(ImageConstants.CLEAR_ICON)} onClick={this.onCloseCreateModal} />
                </div>
                <div className="text-center title">Create {this.state.type == "Diagnostic" ? "Chapter Readiness Test" : this.state.type || "Assessment"}</div>
                <div className="text-center sub-title"><small>{this.state.selectedChapter?.title} - {this.state.orgClass} {this.state.orgSection ? ` ${this.state.orgSection}` : ""}</small></div>
                <div className="pt-4">
                    <div className="row">
                        {
                            this.state.type != "Homework" ?
                                <div className="col-12 pt-4">
                                    <div className="filter-input-label">
                                        Duration
                                    </div>
                                    <PillButton key={'duration'} value={this.state.duration} options={this.durationDropdown} onSelect={this.onSelectDuration} size={'sm'} style={{ fontSize: 15, fontWeight: 'bold' }} />
                                </div> :

                                <div className="col-12 pt-4">
                                    <div className="filter-input-label">
                                        Concepts
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedConcept ? 'error-border concept-dropdown' : ' concept-dropdown'}>

                                        <DropdownV4
                                            className="concept-dropdown"
                                            placeholder='Select a Concept'
                                            options={this.state.conceptDropdown}
                                            onSelect={(option) => this.onMultiSelectDropdown(option, 'selectedConcept')}
                                            text={"title"}
                                            multiSelect={true}
                                            value={this.state.selectedConcept}
                                        />
                                    </div>
                                    {this.props.isCreate && !this.state.selectedConcept ? <div className='error-text text-danger'>Please Select a concept</div> : ''}
                                </div>

                        }


                        <div className="col-12 pt-4">
                            <div className="filter-input-label">
                                Due Date
                            </div>
                            <div className={this.props.isCreate && !this.state.selectedDate ? 'error-border position-relative' : ''}>
                                <DateRangePicker onHide={this.handleDateEvent} onCancel={() => { }}
                                    autoApply={true}
                                    initialSettings={{ singleDatePicker: true, startDate: this.startDate, minDate: this.startDate ? this.startDate : new Date(), autoUpdateInput: false }}
                                    locale={{
                                        'format': 'DD/MM/YYYY'
                                    }}

                                ><input className={`cw-input due-date-input`} placeholder="Select date" value={this.state.selectedDate} ></input>
                                </DateRangePicker>
                            </div>
                            {this.props.isCreate && !this.state.selectedDate ? <div className='error-text text-danger'>Please Select a due date</div> : ''}
                        </div>
                        <div className="col-12 pt-5">
                            <div className="text-center pb-2">
                                {this.state.errMessage ? <span className="text-danger "><strong>{this.state.errMessage}</strong></span> : ""}
                            </div>
                            <button className="cw-button-primary create-button" onClick={() => this.onClickCreate()}>
                                CREATE
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onCLickExternalLink(type, filter) {
        if (filter) {
            filter = {
                ...filter,
                class: this.state.selectedClass,
                board: this.state.selectedBoard,
                sectionId: this.state.selectedSection
            }
        }
        this.setState({ showList: true, type, filter })
    }

    handleBack = () => {
        this.setState({ showList: false, filter: {} })
    }

    render() {

        if (this.state.showList) {
            if (this.state.type == "DIAGNOSTIC") return <TestList filter={this.state.filter} back={this.handleBack} type="DIAGNOSTIC" />
            if (this.state.type == "HOMEWORK") return <HomeworkList type="STANDARD" filter={this.state.filter} back={this.handleBack} />
            if (this.state.type == "ASSESSMENT") return <TestList filter={this.state.filter} back={this.handleBack} type="NORMAL" />
        }

        return (
            <div className='assessment'>

                <div>
                    <span className="screen-title">
                        ASSESSMENTS & HOMEWORKS
                    </span>
                </div>

                <div className="pt-4">
                    {this.renderFilter()}
                </div>

                <div>
                    <div className="row mt-5">
                        <div className="col header-text">Active Students : {this.state.totalActiveStudents}</div>
                        {/* <div className="col text-right my-auto">
                            <span className="mr-2"> <span className="circle-10 orange-circle mr-2"></span><small><strong>On Going </strong></small></span>
                            <span className="mr-2"> <span className="circle-10 red-circle mr-2"></span><small><strong>Not Started</strong></small></span>
                            <span className="mr-2"><span className="circle-10 green-circle mr-2"></span><small><strong>Completed</strong></small></span>

                        </div> */}
                    </div>

                    <div id="table-scoll" className="table-responsive">
                        <table className={`table cw-table mb-0 align-items-center ${this.state.addIndex == this.state.chapters?.length - 1 ? "table-bottom-padding" : ""}`}>
                            <thead>
                                <tr>
                                    <th className='th-left-radius'>Chapters</th>
                                    <th className=''>Chapter Readiness Test
                                        <img className="icon-20 ml-1 cursor-pointer" id="diagnostic-tooltip" alt="" src={getImageSource(ImageConstants.INFO_CIRCLE)} />
                                        <Tooltip placement="top" isOpen={this.state.diagnosticTooltipOpen} autohide={false} target={`diagnostic-tooltip`} toggle={() => { this.setState({ diagnosticTooltipOpen: !this.state.diagnosticTooltipOpen }) }}>
                                            This is about Diagnostic
                                        </Tooltip>
                                        <img className="icon-20 ml-1 cursor-pointer" onClick={() => this.onCLickExternalLink("DIAGNOSTIC")} alt="" src={getImageSource(ImageConstants.EXTERNAL_LINK)} />
                                    </th>
                                    <th className=''>Homework
                                        <img className="icon-20 ml-1 cursor-pointer" alt="" id={`homework-tooltip`} src={getImageSource(ImageConstants.INFO_CIRCLE)} />
                                        <img className="icon-20 ml-1 cursor-pointer" onClick={() => this.onCLickExternalLink("HOMEWORK")} alt="" src={getImageSource(ImageConstants.EXTERNAL_LINK)} />
                                        <Tooltip placement="top" isOpen={this.state.homeworkTooltip} autohide={false} target={`homework-tooltip`} toggle={() => { this.setState({ homeworkTooltip: !this.state.homeworkTooltip }) }}>
                                            This is about Homework
                                        </Tooltip>
                                    </th>
                                    <th className='th-right-radius'>Assignment
                                        <img className="icon-20 ml-1 cursor-pointer" alt="" id={`assessment-tooltip`} src={getImageSource(ImageConstants.INFO_CIRCLE)} />
                                        <img className="icon-20 ml-1 cursor-pointer" onClick={() => this.onCLickExternalLink("ASSESSMENT")} alt="" src={getImageSource(ImageConstants.EXTERNAL_LINK)} />
                                        <Tooltip placement="top" isOpen={this.state.assessmentTooltip} autohide={false} target={`assessment-tooltip`} toggle={() => { this.setState({ assessmentTooltip: !this.state.assessmentTooltip }) }}>
                                            This is about Assessment
                                        </Tooltip>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    this.state.chapters?.length ? this.state.chapters?.map((item, index) => (

                                        <tr key={item._id} className="position-relative" >
                                            <td className=''> 
                                            {/* <span className={`circle-15 ${this.getChapterStatusClass(item.status)} mr-2`}>&nbsp;</span> */}
                                            {item.title} </td>
                                            <td className=''>
                                                <div>
                                                    <span onClick={() => this.onCLickExternalLink("DIAGNOSTIC", { chapterKey: item.key })} >
                                                        <CircularProgressbar
                                                            className="circle-progress mr-2 cursor-pointer"
                                                            value={item.diagnosticCompleted || 0}
                                                            text={`${item.diagnosticCompleted || 0}`}
                                                            maxValue={item.totalDiagnostic || 1}
                                                            styles={buildStyles({ ...this.progressConfig, trailColor: item.totalDiagnostics ? "#FFE4E4" : "#D7D7D7", textColor: item.totalDiagnostics ? '#41A2FC' : "#7D7D7D" })}
                                                        />
                                                    </span>
                                                    <img alt="" className="icon-20 cursor-pointer" onClick={() => this.addDiagnostic(item, index, "Diagnostic")} src={getImageSource(ImageConstants.ADD)} /></div>
                                                {this.state.type == "Diagnostic" && this.state.diagnosticIndex === index ? <div className="mt-2"><div className="cw-card absolute p-4">{this.renderAssessmentCreateCard()}</div></div> : ""}
                                            </td>
                                            <td className=''>
                                                <div>
                                                    <span onClick={() => this.onCLickExternalLink("HOMEWORK", { chapterKey: item.key })}>
                                                        <CircularProgressbar
                                                            className="circle-progress mr-2 cursor-pointer"
                                                            value={item.homworkCompleted || 0}
                                                            text={`${item.homworkCompleted || 0}`}
                                                            maxValue={item.totalHomeworks || 1}
                                                            styles={buildStyles({ ...this.progressConfig, trailColor: item.totalHomeworks ? "#FFE4E4" : "#D7D7D7", textColor: item.totalHomeworks ? '#41A2FC' : "#7D7D7D" })}
                                                        />
                                                    </span>
                                                    <img alt="" className="icon-20 cursor-pointer" onClick={() => this.addHomework(item, index, "Homework")} src={getImageSource(ImageConstants.ADD)} /></div>
                                                {this.state.type == "Homework" && this.state.homeworkIndex === index ? <div className="mt-2"><div className="cw-card absolute p-4">{this.renderAssessmentCreateCard()}</div></div> : ""}

                                            </td>
                                            <td className=''>
                                                <div>
                                                    <span onClick={() => this.onCLickExternalLink("ASSESSMENT", { chapterKey: item.key })}>
                                                        <CircularProgressbar
                                                            className="circle-progress mr-2 cursor-pointer"
                                                            value={item.assessmentCompleted || 0}
                                                            text={`${item.assessmentCompleted || 0}`}
                                                            maxValue={item.totalAssessments || 1}
                                                            styles={buildStyles({ ...this.progressConfig, trailColor: item.totalAssessments ? "#FFE4E4" : "#D7D7D7", textColor: item.totalAssessments ? '#41A2FC' : "#7D7D7D" })}
                                                        />
                                                    </span>
                                                    <img alt="" className="icon-20 cursor-pointer" onClick={() => this.addAssessment(item, index, "Assessment")} src={getImageSource(ImageConstants.ADD)} /></div>
                                                {this.state.type == "Assessment" && this.state.assessmentIndex === index ? <div className="mt-2"><div className="cw-card absolute p-4">{this.renderAssessmentCreateCard()}</div></div> : ""}
                                            </td>
                                        </tr>
                                    ))
                                        :
                                        <tr className="bg-white pt-4"><td colSpan="4" align='center'>No Records found</td></tr>
                                }
                            </tbody>
                        </table>

                    </div >

                </div>
                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position='bottom-center' /> </div> : ""}
                {this.state.showNotification ? this.renderNotificationModal() : ""}
                {this.state.showSuccess ? <SuccessComponent
                    title={`${this.state.type == "Homework" ? "HOMEWORK" : "ASSESSMENT"} CREATED`}
                    students={this.state?.selectedItem?.totalUsers || 0}
                    close={this.closeSuccess}
                    onOk={this.onInviteMoreStudent}
                    class={this.state.orgClass}
                    section={this.state.orgSection}
                /> : ""}

            </div >
        );
    }
}

export default AssessmentList;